import { Button, Flex, Form, FormInstance, Input, Tooltip } from 'antd'
import { antLocale, LocaleType } from '../utils/localization/i18n'
import { MdGTranslate } from 'react-icons/md'
import translate from 'translate'
import { EditPlaylistDTO } from '../utils/redux/playlistsSlice'
import { useState } from 'react'

const { TextArea } = Input

interface Props<T> {
  form: FormInstance<EditPlaylistDTO>
  fieldName: keyof EditPlaylistDTO
  value?: Record<LocaleType, string>
  onChange?: (value: any) => void
}

export default function TextWithTranslationFormItem<T = EditPlaylistDTO>({
  form,
  fieldName,
  value,
  onChange,
}: Props<T>) {
  const enField = Form.useWatch([fieldName, 'en'], form)
  const [isTranslating, setIsTranslating] = useState(false)

  const handleTranslate = async () => {
    if (!enField || enField.length === 0) return

    setIsTranslating(true)
    try {
      const locales = Object.keys(antLocale).filter(
        (locale) => locale !== 'en',
      ) as LocaleType[]

      const translations = await Promise.all(
        locales.map(async (locale) => {
          const translation = await translate(enField, { from: 'en', to: locale })
          return { locale, translation }
        }),
      )

      const toFormValue = translations.reduce(
        (acc, { locale, translation }) => {
          acc[locale] = translation
          return acc
        },
        { en: enField } as Record<LocaleType, string>,
      )

      form.setFieldsValue({ [fieldName]: toFormValue })

      console.log('Translation completed:', translations)
    } catch (error) {
      console.error('Translation error:', error)
    } finally {
      setIsTranslating(false)
    }
  }

  return (
    <Flex vertical style={{ marginLeft: '2em', position: 'relative' }}>
      <Tooltip title="Provide description and english for automatic translation">
        <Button
          icon={<MdGTranslate />}
          shape={'circle'}
          size="small"
          loading={isTranslating}
          style={{ position: 'absolute', top: -40, right: 0 }}
          disabled={!enField || enField.length === 0}
          onClick={handleTranslate}
        />
      </Tooltip>
      {Object.keys(antLocale).map((locale, idx) => (
        <Form.Item
          key={locale}
          name={[fieldName, locale]}
          // label={locale.toUpperCase()}
          // labelCol={{ flex: '60px' }}
          labelAlign="left"
          rules={[{ required: locale === 'en' }]}
        >
          <TextArea autoSize placeholder={locale.toUpperCase()} />
        </Form.Item>
      ))}
    </Flex>
  )
}
